"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MercanetResponseStatusMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class MercanetResponseStatusMapper {
    toDomain(result) {
        const transactionSuccess = lodash_1.default.get(result, "data.mercanetV2Status.transactionSuccess");
        const refillSuccess = lodash_1.default.get(result, "data.mercanetV2Status.refillSuccess");
        const isNetworkError = lodash_1.default.get(result, "data.networkStatus") === 8;
        return {
            transactionSuccess,
            refillSuccess,
            isNetworkError,
        };
    }
}
exports.MercanetResponseStatusMapper = MercanetResponseStatusMapper;
